const styles = `:host {
  position: relative;
}
:host .content {
  display: flex;
}

:host([nowrap]) ::slotted([slot=tooltip]) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}`; export default styles;